/**
 * NjitFindYourAdmissionsCounselor behaviour.
 */

(function (Drupal, $) {
  "use strict";

  Drupal = Drupal || {};

  Drupal.settings = Drupal.settings || {};

  /**
   * JS Behaviour.
   *
   * @type {{attach: Drupal.behaviors.NjitFindYourAdmissionsCounselor.attach}}
   */
  Drupal.behaviors.NjitFindYourAdmissionsCounselor = {
    attach: function (context, settings) {
      ////////////////////////////////////////////////////////
      // Form filter events.
      ////////////////////////////////////////////////////////

      var $modal = $('.modal-your-admissions-counselor');
      var $fyacStudent = $('select[name="fyac-student"]', $modal);
      var $fyacCollege = $('select[name="fyac-college"]', $modal);
      var $fyacState = $('select[name="fyac-state"]', $modal);
      var $fyacCounty = $('select[name="fyac-county"]', $modal);

      populaceForm();
      $($fyacStudent).change(function() {
        // Reset values.
        $fyacCollege.val('').trigger("change");
        $fyacState.val('').trigger("change");
        $fyacCounty.val('').trigger("change");
        // Re-populace the form.
        populaceForm();
      });
      $($fyacCollege).change(function() {
        $fyacState.val('').trigger("change");
        $fyacCounty.val('').trigger("change");
        populaceForm();
      });
      $($fyacState).change(function() {
        $fyacCounty.val('').trigger("change");
        populaceForm();
      });
      $($fyacCounty).change(function() {
        populaceForm();
      });

      function populaceForm() {
        var fyacStudent = $fyacStudent.val();
        var fyacCollege = $fyacCollege.val();
        var fyacState = $fyacState.val();
        var fyacCounty = $fyacCounty.val();

        $('.item-college', $modal).hide();
        $('.item-state', $modal).hide();
        $('.item-county', $modal).hide();

        // Show/hide drop-downs.
        switch (fyacStudent) {
          case 'undergraduate':
            $('.item-state', $modal).show();
            break;
          case 'graduate':
            $('.item-college', $modal).show();
            break;
          case 'transfer':
          default:
            break;
        }

        switch (fyacState) {
          case 'ny':
          case 'nj':
          case 'pa':
            $('.item-county', $modal).show();
            break;
          default:
            break;
        }

        // Disable/Enable the button.
        var flag = false;
        switch (fyacStudent) {
          case 'undergraduate':
            if (fyacState !== '') {
              if (fyacState === 'ny' || fyacState === 'nj' || fyacState === 'pa') {
                if (fyacCounty !== '') {
                  flag = true;
                }
              }
              else {
                flag = true;
              }
            }
            break;
          case 'graduate':
            if (fyacCollege !== '') {
              flag = true;
            }
            break;
          case 'transfer':
            flag = true;
            break;

          default:
            break;
        }
        if (flag) {
          $('button.find', $modal).removeAttr('disabled');
          $('button.find', $modal).on('click', function() {
            $('.step-finish', $modal).removeClass('disabled').click();
          });
        }
        else {
          $('button.find', $modal).attr('disabled', 'disabled');
        }

        // Resize colorbox.
        $.colorbox.resize();
      }

      ////////////////////////////////////////////////////////
      // Step navigation events.
      ////////////////////////////////////////////////////////

      $('ul.form-progress-nav li', $modal).on('click', function () {
        if (!$(this).hasClass('disabled')) {
          $('ul.form-progress-nav li', $modal).each(function () {
            $(this).removeClass('active');
          });
          $(this).addClass('active');

          if ($(this).hasClass('step-about-you')) {
            $('.section-about-you', $modal).show();
            $('.section-finish', $modal).hide();
            $('.step-finish', $modal).addClass('disabled');

            //$fyacStudent.val('').trigger("change");
            //$fyacCollege.val('').trigger("change");
            //$fyacState.val('').trigger("change");
            //$fyacCounty.val('').trigger("change");
          }
          else {
            $('.section-about-you', $modal).hide();
            $('.section-finish', $modal).show();
          }
        }
        $.colorbox.resize();
      });

      ////////////////////////////////////////////////////////
      // Find button events.
      ////////////////////////////////////////////////////////

      $('button.find', $modal).on('click', function() {
        //Drupal.attachBehaviors(Drupal.NjitTabbedContent);
      });

      ////////////////////////////////////////////////////////
      // Start Over button events.
      ////////////////////////////////////////////////////////

      $('.step-back', $modal).on('click', function () {
        // Reset values.
        //$fyacStudent.val('').trigger("change");
        //$fyacCollege.val('').trigger("change");
        //$fyacState.val('').trigger("change");
        //$fyacCounty.val('').trigger("change");

        $('.step-about-you', $modal).click();
        $.colorbox.resize();
      });

      ////////////////////////////////////////////////////////
      // Colorbox.
      ////////////////////////////////////////////////////////

      $(".button-your-admissions-counselor").colorbox({
        fixed: false,
        scrolling: true,
        overlayClose: false,
        escKey: false,
        inline: true,
        width: '1097px',
        height: '100%',
        top: '129px',
        className: 'colorbox-njit',
        onOpen: function() {

        },
        onComplete: function() {
          //Drupal.attachBehaviors(Drupal.NjitTabbedContent);
        },
        onClosed: function() {
          // Reset values.
          $fyacStudent.val('').trigger("change");
          $fyacCollege.val('').trigger("change");
          $fyacState.val('').trigger("change");
          $fyacCounty.val('').trigger("change");
          // Go back to the step 1.
          $('.step-about-you', $modal).click();
        }
      });
    }
  };
})(Drupal, jQuery);
